function formatZodErrors(errors) {
  return errors.map((err) => {
    const path = err.path.length > 0 ? ` at ${err.path.join(".")}` : "";
    return `${err.message}${path}`;
  });
}
class DecodeError extends Error {
  name = "DecodeError";
  input;
  errors;
  constructor(args) {
    const formattedErrors = formatZodErrors(args.errors);
    super(formattedErrors.join(", "));
    this.input = args.input;
    this.errors = formattedErrors;
  }
}
export {
  DecodeError
};
//# sourceMappingURL=DecodeError.js.map
